import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Formik } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
// import Snackbar from '@material-ui/core/Snackbar';
// import Alert from '@material-ui/lab/Alert';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DialogActions from '@material-ui/core/DialogActions';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
// import IconButton from '@material-ui/core/IconButton';
// import CloseIcon from '@material-ui/icons/Close';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Tooltip from '@material-ui/core/Tooltip';
import './styles.css';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import PreviewImage from '../../../assets/previewImage.png';
import downloadImage from '../../../assets/downloadImage.png';
import PreviewModal from '../../../components/modal/previewModal';
import TabList from '../../../components/checklistTab/tabList';
import buttonDisable from '../../../components/disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';
import PreWhite from '../../../assets/pre_white.png';
import DownWhite from '../../../assets/down_white.png';

const useStyles = makeStyles((theme) => ({
    root: {
        // boxShadow: '0px 5px 10px #efefef !important',
        // borderRadius: '8px',
        // // padding: '20px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        marginRight: '20px !important',
        ['@media (max-width:600px)']: {
            marginRight: '8px !important',
        },
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        display: 'inline-flex',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },
    payonline: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    downloadImg: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '9px',
        left: '0px',
    },
    downloadImageView: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '6px',
        left: '0px',
    },
    imageView: {
        paddingBottom: '12px',
        textAlign: 'center',
        background: '#e8e7e7',
        padding: '10px 7px 10px 7px',
        borderRadius: '5px',
        position: 'relative',
        top: '1px',
    },
    imageViewList: {
        paddingBottom: '12px',
        textAlign: 'center',
        background: '#e8e7e7',
        padding: '5px 7px 10px 7px',
        borderRadius: '5px',
        position: 'relative',
        top: '1px',
        display: 'flex',
    },
}));

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function ClientFinalDocument() {
    const history = useHistory();
    const classes = useStyles();
    // const bull = <span className={classes.bullet}>•</span>;

    console.log('userType', userType);
    const [state, setState] = React.useState({
        checkedA: true,
    });
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [showonlineDiv, setonlineDiv] = useState('block');
    const [showofflineDiv, setofflineDiv] = useState('none');
    const [bankDefaults, setBankDefaults] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [finalCompFilename, setFinalCompFilename] = useState('');
    const [checklist, setChecklist] = useState('');
    const [URLValue, setURLValue] = useState();
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [attachedFilename, setAttachedFilename] = useState('');
    const [attachedFilenameFile, setAttachedFilenameFile] = useState('');
    console.log('attachedFilenameFile', attachedFilenameFile);

    const [attachedFilenameFileAfterEM, setAttachedFilenameFileAfterEM] = useState('');
    console.log('attachedFilenameFileAfterEM', attachedFilenameFileAfterEM);

    const [transferChallanAfterEM, setTransferChallanAfterEM] = useState('');

    const [transferChallan, setTransferChallan] = useState('');
    console.log('transferChallan', transferChallan);
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [uploadDisable, setUploadDisable] = useState(true);
    const [isDisable, setIsDisable] = useState(true);
    const [isDisableCancel, setIsDisableCancel] = useState(true);
    const [isDisableClose, setIsDisableClose] = useState(true);
    const [visible, setVisible] = React.useState(false);
    // const coreFilename = [];
    const [downloadPath, setDownloadPath] = useState('');
    const [taxtype, setTaxType] = React.useState('online');
    console.log('taxtype', taxtype);

    const [bankDetailsValue, setBankDetailsValue] = useState([]);
    const [finalDraft, setFinalDraft] = useState([]);
    console.log('finalDraft', finalDraft);

    const [finalView, setFinalView] = useState(false);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const [radioValue, setRadioValue] = useState('online');
    console.log('radioValue', radioValue);

    const finalCompDownloadFile = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${
        checklist && checklist.finalComputationDocument
    }`;

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    useEffect(
        (data) => {
            axios.get(`${CommonConfig.dev.baseUrl}/api/auth/bankdetails/${dbname}`, axiosConfig).then((response) => {
                setBankDefaults(response.data);
            });
            axios.get(`${CommonConfig.dev.baseUrl}/api/auth/bankdetails-tax/${dbname}`, axiosConfig).then((response) => {
                if (response) {
                    setBankDetailsValue(response.data);
                }
            });
            axios
                .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${dbname}/${serviceIdValue}`, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    console.log('responseclient', response.data);
                    setFinalDraft(response.data['finalComputationDocument']);

                    setRadioValue(response.data['payonline'] ? 'online' : 'offline');
                    const filename = response.data['finalComputationDocument'];
                    const transferchallanfile = response.data.taxChalanOrAcknowledgement;
                    setAttachedFilenameFile(transferchallanfile.substring(transferchallanfile.lastIndexOf('/') + 1));
                    const transferchallanafterEM = response.data.transferchallan;
                    setAttachedFilenameFileAfterEM(transferchallanafterEM.substring(transferchallanafterEM.lastIndexOf('/') + 1));
                    setTransferChallan(transferchallanfile);
                    setTransferChallanAfterEM(transferchallanafterEM);
                    setFinalCompFilename(filename.substring(filename.lastIndexOf('/') + 1));
                    // const transferchallanfile = response.data.transferchallan;
                    setChecklist(response.data);
                    setFinalView(response.data.paidTax);
                })
                .catch((error) => {});
        },
        [bearerToken]
    );

    const handleRoleChange = (event) => {
        setTaxType(event.target.value);
        switch (event.target.value) {
            case 'online':
                setonlineDiv('block');
                setofflineDiv('none');
                return true;
            case 'offline':
                setonlineDiv('none');
                setofflineDiv('block');
                return true;
            default:
                return true;
        }
    };

    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(pdf)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setUploadDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                    setIsDisableClose(true);
                    setIsDisableCancel(false);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e pdf');
                setIsDisable(true);
            }
        }
    };

    const fileUpload = () => {
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/${serviceIdValue}/myimage`, data, axiosConfig)
            .then((response) => {
                //console.log('response', response.data);
                if (response.data) {
                    setURLValue(response.data);
                    setAttachedFilename(filename);
                    setIsDisable(false);
                    setUploadSuccessfully('Uploaded a file successfully');
                    setTimeout(() => {
                        closeDialog();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data) {
                    setIsDisable(true);
                    setIsDisableClose(false);
                    setIsDisableCancel(true);
                }
            });
    };

    const handleClose = () => {
        setShowBtnLoader(false);
        setHandleOpen(false);
    };

    const downloadFile = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${checklist && checklist.finalComputationDocument}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    const handleClick = () => {
        setHandleOpen(true);
        setUploadSuccessfully('');
        setUploadDisable(true);
        setClearData('');
        setIsDisableCancel(true);
    };

    const closeDialog = () => {
        setHandleOpen(false);
        setIsfileInvalid('');
        setFilename(null);
    };

    const handleDisable = (value) => {
        setIsDisable(value);
    };

    const initialValues = {
        URL: '',
        comments: '',
    };

    // const formik = useFormik({
    //     initialValues: {
    //         comments: comments,
    //     },
    //     validationSchema: Yup.object().shape({

    //     }),
    //     onSubmit: (values) => {
    //         //console.log('values',values);
    //         setShowBtnLoader(true);
    //         const data = {
    //             intclientName: values.intclientName,
    //             corpClientName: values.corporatename,
    //             addressId: {
    //                 addressId: values.addressId,
    //                 addressLine1: values.addressline1,
    //                 addressLine2: values.addressline2,
    //                 city: values.city,
    //                 stateId: {
    //                     id: selectedStateId,
    //                 },
    //                 pinCode: values.pin,
    //                 country: values.country,
    //             },
    //             govtRegNumber: values.govtRegNumber,
    //             pan: values.pan,
    //             gstin: values.gstin,
    //             pin: values.pin,
    //             isActive: values.isActive,
    //             corpclientId: values.corpclientId,
    //             typeOfEntity: values.typeOfEntity,
    //             dateofIncorporation: values.dateofIncorporationValue,
    //             person1Name: values.person1Name,
    //             person1Designation: values.person1Designation,
    //             person1Mobile: values.person1Mobile,
    //             person1Mobnumber: values.person1Mobnumber,
    //             person1Emailid: values.person1Emailid,
    //             person2Name: values.person2Name,
    //             person2Designation: values.person2Designation,
    //             person2Mobile: values.person2Mobile,
    //             person2Mobnumber: values.person2Mobnumber,
    //             person2Emailid: values.person2Emailid,
    //             // prefmodeCommunication: commStr,
    //             // preflangCommunication: langStr,
    //             prefmodeCommunication: values.prefComm,
    //             preflangCommunication: values.prefLang,
    //             // prefModecommu: commStr,
    //             // prefLangcommu: langStr,
    //             webSite: values.website,
    //             tennantName: values.intclientName,
    //             dsc1PersonName: values.dsc1PersonName,
    //             dsc1ValidityStartdate: values.dsc1StartDate,
    //             dsc1ValidityEnddate: values.dsc1EndDate,
    //             dsc1Password: values.dsc1Password,
    //             dsc1PhysicalAvailability: values.dsc1Physical,
    //             dsc2PersonName: values.dsc2PersonName,
    //             dsc2ValidityStartdate: values.dsc2StartDate,
    //             dsc2ValidityEnddate: values.dsc2EndDate,
    //             dsc2Password: values.dsc2Password,
    //             dsc2PhysicalAvailability: values.dsc2Physical,
    //             gstFiles: URLValueGst && URLValueGst.length ? URLValueGst : '',
    //             panFiles: URLValuePan && URLValuePan.length ? URLValuePan : '',
    //             contactPerson2Required: values.contactPerson2Required,
    //             // dsc1PersonName: values.dsc1PersonName,
    //             // dsc1StartDate: values.dsc1StartDate,
    //             // dsc1EndDate: values.dsc1EndDate,
    //             // dsc1Password: values.dsc1Password,
    //             // dsc1Physical: values.dsc1Physical,
    //             // dsc2PersonName: values.dsc2PersonName,
    //             // dsc2StartDate: values.dsc2StartDate,
    //             // dsc2EndDate: values.dsc2EndDate,
    //             // dsc2Password: values.dsc2Password,
    //             // dsc2Physical: values.dsc2Physical
    //         };
    //         console.log("data", data);
    //         axios
    //             .put(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/`, data, axiosConfig)
    //             .then((response) => {
    //                 setShowBtnLoader(false);
    //                 setSuccessPop(true);
    //                 setTimeout(() => {
    //                     usertype === 'SUPERADMIN' ?
    //                         props.history.push({
    //                             pathname: '/menu/corporateclientsitec',
    //                             state: { domainname }
    //                         })
    //                         :
    //                         props.history.push({
    //                             pathname: '/menu/ClientCorporateView',
    //                         });
    //                 }, 3000);
    //             })
    //             .catch((error) => {
    //                 const errResult = error.response;
    //                 if (errResult.data) {
    //                     setShowBtnLoader(false);
    //                     setErrorPop(true);
    //                     setTimeout(() => {
    //                         setErrorPop(false);
    //                     }, 5000);
    //                     setErrorMsgGenerateRecceipt(errResult.data.message);
    //                 }
    //             });
    //     },
    // });

    const handleSubmit = (values) => {
        console.log('values', values);
        setShowBtnLoader(true);
        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            finalDocumentAndReports: {
                finalComputationDocument: finalDraft,
                itrAcknowledgement: '',
                taxChalanOrAcknowledgement: taxtype === 'online' ? URLValue : '',
                transferToAccount: false,
                payonline: taxtype === 'online' ? true : false,
                stage: 'finalDocumentAndReports',
                descriptionForInvoice: 'descriptionForInvoice',
                amountForInvoice: '1111',
                reports: 'Structure is not finalized',
                transferchallan: taxtype === 'online' ? '' : URLValue,
                paidTax: finalView,
                commentsbyclient: values.comments,
            },
        };

        // console.log('handleSubmitClick', data);

        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/approval-client/${dbname}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log('ClientFinalDocResponse', response.data);
                if (response.data === 'SUCCESS') {
                    setShowBtnLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        history.push({
                            pathname: '/menu/openservice',
                        });
                    }, 3000);
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setShowBtnLoader(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        console.log('file', file);
        setDownloadPath(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');

                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                // Start download
                link.click();
            });
    };

    return (
        <div>
            {/* <Snackbar
                    className="deleteError"
                    open={updateStat}
                    anchorOrigin={{ vertical, horizontal }}
                    autoHideDuration={3000}
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    <Alert
                        onClose={() => {
                            setUpdateStat(false);
                        }}
                    >
                        Successfully Approved the Final Document
                    </Alert>
                </Snackbar> */}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Approved the Tax payment" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}
            {/* <div className="stage-indicator">
                <ul>
                    <li>L1 Checklist</li>
                    <li>L1 CRC Confirmed</li>
                    <li>Draft Statements</li>
                    <li className="active">Tax Payment and Filing </li>
                </ul>
            </div> */}
            <TabList />

            <Formik
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <form className="itecform" onSubmit={formik.handleSubmit}>
                            <Card className={classes.root}>
                                {/* <CardContent className="client-heading">
                                <Typography variant="h5">Bank account Details</Typography>
                            </CardContent> */}
                                <CardContent>
                                    <Grid container spacing={3} className="main-container">
                                        {stageId === 20 ? (
                                            <Grid item xs={12} sm={12}>
                                                <Typography className="final-doc-title1">Tax Payment and Filing</Typography>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} sm={12}>
                                                <Typography className="final-doc-title1" align="center">
                                                    Tax Payment and Filing
                                                </Typography>
                                            </Grid>
                                        )}
                                        {stageId === 20 ? (
                                            <Grid item xs={12} sm={12}>
                                                <FormControl>
                                                    <RadioGroup
                                                        defaultValue="online"
                                                        // aria-label="business"
                                                        name="customized-radios"
                                                        onChange={handleRoleChange}
                                                        className="radio-option"
                                                    >
                                                        <ul className={classes.payonline}>
                                                            <li>
                                                                <FormControlLabel
                                                                    id="online"
                                                                    value="online"
                                                                    defaultChecked="true"
                                                                    control={<StyledRadio />}
                                                                    label="I agree to pay the tax and share the challan"
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormControlLabel
                                                                    id="offline"
                                                                    value="offline"
                                                                    control={<StyledRadio />}
                                                                    label="I agree to transfer amount to your bank account"
                                                                />
                                                            </li>
                                                        </ul>
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                        ) : radioValue === 'online' ? (
                                            <div className="pl10">I agree to pay the tax and share the challan</div>
                                        ) : (
                                            <div className="pl10">I agree to transfer amount to your bank account</div>
                                        )}

                                        {stageId === 20 ? (
                                            <Grid item xs={12} sm={12} className="offlinediv" style={{ display: showofflineDiv }}>
                                                <hr className="invoicedividertag" />
                                                <Grid item xs={12} sm={12}>
                                                    <div className="subtitle">Transfer money to the below account details</div>
                                                    <div className="dividerinvoicediv offlinedivider" />
                                                </Grid>
                                                {/* {bankDefaults.length > 0 ? */}
                                                {bankDetailsValue &&
                                                    bankDetailsValue.map((bankDetails) => {
                                                        // if (bankDetails.isDefault == true) {
                                                        return (
                                                            <Grid item xs={12} sm={12}>
                                                                <FormControl fullWidth>
                                                                    <div className="particulars">
                                                                        Bank Name : <span> {bankDetails.bankName}</span>{' '}
                                                                    </div>
                                                                </FormControl>

                                                                <FormControl fullWidth>
                                                                    <div className="particulars">
                                                                        A/c No : <span> {bankDetails.accountNumber} </span>
                                                                    </div>
                                                                </FormControl>

                                                                <FormControl fullWidth>
                                                                    <div className="particulars">
                                                                        Branch & IFSC Code :{' '}
                                                                        <span>
                                                                            {bankDetails.branch} & {bankDetails.ifscCode}
                                                                        </span>
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>
                                                        );
                                                        // }
                                                    })}
                                                {/* : null} */} <br></br>
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel className="lbl" htmlFor="comments" shrink style={{ color: '#000' }}>
                                                            Remarks
                                                        </InputLabel>
                                                        <Input
                                                            type="text"
                                                            className="bottom"
                                                            rowsMin={3}
                                                            onChange={formik.handleChange}
                                                            name="comments"
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.comments}
                                                        />
                                                        {formik.touched.comments && formik.errors.comments ? (
                                                            <span className="itec-validationError">{formik.errors.comments}</span>
                                                        ) : null}
                                                    </FormControl>
                                                </Grid>
                                                <br></br>
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl fullWidth className="mt50 btn-center">
                                                        <ul className={classes.inlinebutton}>
                                                            <li>
                                                                <span>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        size="small"
                                                                        className={classes.button}
                                                                        onClick={handleClick}
                                                                    >
                                                                        Attach Proof
                                                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                                                    </Button>
                                                                    {/* <p className="fileName">{attachedFilename}</p> */}
                                                                    {attachedFilename ? (
                                                                        <span className={classes.imageView}>
                                                                            <span style={{ marginRight: '7px' }}>
                                                                                {attachedFilename.substring(0, 15)}
                                                                                {attachedFilename.length > 15 ? '...' : ''}
                                                                            </span>
                                                                            {/* <span style={{ marginRight: '8px' }} className="fileName">{attachedFilename}</span> */}
                                                                            {attachedFilename ? (
                                                                                <span onClick={() => handlePreviewModal(URLValue)}>
                                                                                    <Tooltip title="Preview">
                                                                                        <img
                                                                                            src={PreviewImage}
                                                                                            alt="PreviewImage"
                                                                                            className="fileView"
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                            {attachedFilename ? (
                                                                                <span onClick={() => downloadCoreFile(URLValue)}>
                                                                                    <Tooltip title="Download">
                                                                                        <img
                                                                                            src={downloadImage}
                                                                                            alt="downloadImage"
                                                                                            className={classes.downloadImg}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                        </span>
                                                                    ) : null}

                                                                    <PreviewModal
                                                                        fileSource={downloadPath}
                                                                        visibleClose={visible}
                                                                        handleModalClose={handleModalClose}
                                                                    />
                                                                </span>
                                                            </li>
                                                        </ul>

                                                        <Dialog
                                                            onClose={handleClose}
                                                            // PaperProps={{
                                                            //     className: 'QandADailogBox',
                                                            //     style: { padding: '20px' }
                                                            // }}
                                                            aria-labelledby="form-dialog-title"
                                                            // eslint-disable-next-line react/destructuring-assignment
                                                            open={handleOpen}
                                                            clear={clearData}
                                                            // disableBackdropClick
                                                        >
                                                            {/* <DialogTitle id="form-dialog-title">Upload File</DialogTitle> */}
                                                            <DialogTitle id="form-dialog-title">
                                                                Upload File
                                                                {/* <IconButton
                                                            aria-label="close"
                                                            className={classes.closeButton}
                                                            onClick={closeDialog}
                                                        // onClick={onClose}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton> */}
                                                            </DialogTitle>
                                                            <DialogContent
                                                                style={{
                                                                    textAlign: 'center',
                                                                }}
                                                            >
                                                                <Button
                                                                    className="btnOrange"
                                                                    // disabled={isDisableAddFile}
                                                                    variant="outlined"
                                                                    component="label"
                                                                    color="default"
                                                                >
                                                                    <i className="btnIcon">
                                                                        <FontAwesomeIcon icon={faPlus} />
                                                                    </i>{' '}
                                                                    Add File
                                                                    <input
                                                                        onChange={(e) => isFileUpload(e, e.target.files)}
                                                                        type="file"
                                                                        style={{
                                                                            display: 'none',
                                                                        }}
                                                                        accept="application/pdf"
                                                                    />
                                                                </Button>

                                                                {!isfileInvalid && filename ? (
                                                                    <p className="fileName">
                                                                        {filename.substring(0, 15)}
                                                                        {filename.length > 15 ? '...' : ''}
                                                                    </p>
                                                                ) : null}
                                                            </DialogContent>
                                                            <p className="fileNameRed">{isfileInvalid}</p>
                                                            <p className="fileNameGreen">{uploadSuccessfully}</p>
                                                            <DialogActions className="paddingBtm txtCenter">
                                                                <Button
                                                                    className="btnBluepop"
                                                                    onClick={fileUpload}
                                                                    variant="contained"
                                                                    disabled={uploadDisable}
                                                                    component="label"
                                                                    color="default"
                                                                >
                                                                    {/* <i className="btnIcon">
                                                                        <FontAwesomeIcon icon={faUpload} />
                                                                    </i>{' '} */}
                                                                    Upload
                                                                </Button>
                                                                <Button
                                                                    className="btnBluepop"
                                                                    // disabled={uploadSuccessfully.length}
                                                                    // disabled={isDisableCancel}
                                                                    onClick={closeDialog}
                                                                    variant="contained"
                                                                    component="label"
                                                                    color="default"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </FormControl>
                                                    {/* <Button
                                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        className={classes.button}
                                                        // startIcon={<InsertCommentIcon />}
                                                     
                                                    >
                                                        Remarks
                                                        
                                                </Button>     */}
                                                </Grid>
                                            </Grid>
                                        ) : radioValue === 'offline' ? (
                                            <Grid item xs={12} sm={12} className="offlinediv">
                                                <hr className="invoicedividertag" />
                                                <Grid item xs={12} sm={12}>
                                                    <div className="subtitle">Transfer money to the below account details</div>
                                                    <div className="dividerinvoicediv offlinedivider" />
                                                </Grid>
                                                {/* {bankDefaults.length > 0 ? */}
                                                {bankDetailsValue &&
                                                    bankDetailsValue.map((bankDetails) => {
                                                        // if (bankDetails.isDefault == true) {
                                                        return (
                                                            <Grid item xs={12} sm={12}>
                                                                <FormControl fullWidth>
                                                                    <div className="particulars">
                                                                        Bank Name : <span> {bankDetails.bankName}</span>{' '}
                                                                    </div>
                                                                </FormControl>

                                                                <FormControl fullWidth>
                                                                    <div className="particulars">
                                                                        A/c No : <span> {bankDetails.accountNumber} </span>
                                                                    </div>
                                                                </FormControl>

                                                                <FormControl fullWidth>
                                                                    <div className="particulars">
                                                                        Branch & IFSC Code :{' '}
                                                                        <span>
                                                                            {bankDetails.branch} & {bankDetails.ifscCode}
                                                                        </span>
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>
                                                        );
                                                        // }
                                                    })}
                                                {/* : null} */} <br></br>
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel className="lbl" htmlFor="comments" shrink style={{ color: '#000' }}>
                                                            Remarks
                                                        </InputLabel>
                                                        <Input
                                                            // type="text"
                                                            className="bottom"
                                                            rowsMin={3}
                                                            // onChange={formik.handleChange}
                                                            name="comments"
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.comments}
                                                            disabled
                                                        />
                                                        {formik.touched.comments && formik.errors.comments ? (
                                                            <span className="itec-validationError">{formik.errors.comments}</span>
                                                        ) : null}
                                                    </FormControl>
                                                </Grid>
                                                <br></br>
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl fullWidth className="mt50 btn-center">
                                                        <ul className={classes.inlinebutton}>
                                                            <li>
                                                                <span>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        size="small"
                                                                        className={classes.button}
                                                                        onClick={handleClick}
                                                                        disabled={buttonDisable(stageId, userType.value)}
                                                                    >
                                                                        Attach Proof
                                                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                                                    </Button>
                                                                    {/* <p className="fileName">{attachedFilename}</p> */}
                                                                    {attachedFilenameFileAfterEM ? (
                                                                        <span className={classes.imageView}>
                                                                            <span style={{ marginRight: '7px' }}>
                                                                                {attachedFilenameFileAfterEM.substring(0, 15)}
                                                                                {attachedFilenameFileAfterEM.length > 15 ? '...' : ''}
                                                                            </span>
                                                                            {/* <span style={{ marginRight: '8px' }} className="fileName">{attachedFilename}</span> */}
                                                                            {attachedFilenameFileAfterEM ? (
                                                                                <span
                                                                                    onClick={() =>
                                                                                        handlePreviewModal(transferChallanAfterEM)
                                                                                    }
                                                                                >
                                                                                    <Tooltip title="Preview">
                                                                                        <img
                                                                                            src={PreviewImage}
                                                                                            alt="PreviewImage"
                                                                                            className="fileView"
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                            {attachedFilenameFileAfterEM ? (
                                                                                <span
                                                                                    onClick={() => downloadCoreFile(transferChallanAfterEM)}
                                                                                >
                                                                                    <Tooltip title="Download">
                                                                                        <img
                                                                                            src={downloadImage}
                                                                                            alt="downloadImage"
                                                                                            className={classes.downloadImg}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                        </span>
                                                                    ) : null}

                                                                    <PreviewModal
                                                                        fileSource={downloadPath}
                                                                        visibleClose={visible}
                                                                        handleModalClose={handleModalClose}
                                                                    />
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        ) : null}

                                        {stageId === 20 ? (
                                            <Grid item xs={12} sm={12}>
                                                <div className="offlinediv" style={{ display: showonlineDiv }}>
                                                    {/* <Grid item xs={12} sm={12}> */}
                                                    <FormControl fullWidth className="mt50 btn-center">
                                                        <ul className={classes.inlinebutton}>
                                                            <li>
                                                                <span>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        size="small"
                                                                        className={classes.button}
                                                                        onClick={handleClick}
                                                                    >
                                                                        Attach Challan
                                                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                                                    </Button>
                                                                    {attachedFilename ? (
                                                                        <span className={classes.imageView}>
                                                                            <span className="fntSmall" style={{ marginRight: '7px' }}>
                                                                                {attachedFilename.substring(0, 15)}
                                                                                {attachedFilename.length > 15 ? '...' : ''}
                                                                            </span>
                                                                            {/* <span style={{ marginRight: '8px' }} className="fileName">{attachedFilename}</span> */}
                                                                            {attachedFilename ? (
                                                                                <span onClick={() => handlePreviewModal(URLValue)}>
                                                                                    <Tooltip title="Preview">
                                                                                        <img
                                                                                            src={PreviewImage}
                                                                                            alt="PreviewImage"
                                                                                            className="fileView"
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                            {attachedFilename ? (
                                                                                <span onClick={() => downloadCoreFile(URLValue)}>
                                                                                    <Tooltip title="Download">
                                                                                        <img
                                                                                            src={downloadImage}
                                                                                            alt="downloadImage"
                                                                                            className={classes.downloadImg}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                        </span>
                                                                    ) : null}
                                                                    <PreviewModal
                                                                        fileSource={downloadPath}
                                                                        visibleClose={visible}
                                                                        handleModalClose={handleModalClose}
                                                                    />
                                                                </span>
                                                            </li>
                                                        </ul>

                                                        <Dialog
                                                            onClose={handleClose}
                                                            PaperProps={{
                                                                className: 'QandADailogBox',
                                                                style: { padding: '20px' },
                                                            }}
                                                            aria-labelledby="form-dialog-title"
                                                            // eslint-disable-next-line react/destructuring-assignment
                                                            open={handleOpen}
                                                            clear={clearData}
                                                            // disableBackdropClick
                                                        >
                                                            {/* <DialogTitle id="form-dialog-title">Upload File</DialogTitle> */}
                                                            <DialogTitle id="form-dialog-title">
                                                                Upload File
                                                                {/* <IconButton
                                                            aria-label="close"
                                                            className={classes.closeButton}
                                                            onClick={closeDialog}
                                                        // onClick={onClose}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton> */}
                                                            </DialogTitle>
                                                            <DialogContent
                                                                style={{
                                                                    textAlign: 'center',
                                                                }}
                                                            >
                                                                <Button
                                                                    className="btnOrange"
                                                                    // disabled={isDisableAddFile}
                                                                    variant="outlined"
                                                                    component="label"
                                                                    color="default"
                                                                >
                                                                    <i className="btnIcon">
                                                                        <FontAwesomeIcon icon={faPlus} />
                                                                    </i>{' '}
                                                                    Add File
                                                                    <input
                                                                        onChange={(e) => isFileUpload(e, e.target.files)}
                                                                        type="file"
                                                                        style={{
                                                                            display: 'none',
                                                                        }}
                                                                        accept="application/pdf"
                                                                    />
                                                                </Button>
                                                                {filename ? (
                                                                    <p className="fileName">
                                                                        {filename.substring(0, 15)}
                                                                        {filename.length > 15 ? '...' : ''}
                                                                    </p>
                                                                ) : null}
                                                                {/* <p className="fileName">{filename}</p> */}
                                                            </DialogContent>
                                                            <p className="fileNameGreen">{uploadSuccessfully}</p>
                                                            <DialogActions className="paddingBtm txtCenter">
                                                                <Button
                                                                    className="btnBluepop"
                                                                    onClick={fileUpload}
                                                                    variant="contained"
                                                                    disabled={uploadDisable}
                                                                    component="label"
                                                                    color="default"
                                                                >
                                                                    Upload
                                                                </Button>
                                                                <Button
                                                                    className="btnBluepop"
                                                                    onClick={closeDialog}
                                                                    variant="contained"
                                                                    component="label"
                                                                    color="default"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </FormControl>
                                                </div>
                                            </Grid>
                                        ) : radioValue === 'online' ? (
                                            <Grid item xs={12} sm={12}>
                                                <div className="offlinediv">
                                                    {/* <Grid item xs={12} sm={12}> */}
                                                    <FormControl fullWidth className="mt50 btn-center">
                                                        <ul className={classes.inlinebutton}>
                                                            <li>
                                                                <span>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        size="small"
                                                                        className={classes.button}
                                                                        onClick={handleClick}
                                                                        disabled={buttonDisable(stageId, userType.value)}
                                                                    >
                                                                        Attach Challan
                                                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                                                    </Button>
                                                                    {attachedFilenameFile ? (
                                                                        <span className={classes.imageView}>
                                                                            <span className="fntSmall" style={{ marginRight: '7px' }}>
                                                                                {attachedFilenameFile.substring(0, 15)}
                                                                                {attachedFilenameFile.length > 15 ? '...' : ''}
                                                                            </span>
                                                                            {/* <span style={{ marginRight: '8px' }} className="fileName">{attachedFilename}</span> */}
                                                                            {attachedFilenameFile ? (
                                                                                <span onClick={() => handlePreviewModal(transferChallan)}>
                                                                                    <Tooltip title="Preview">
                                                                                        <img
                                                                                            src={PreviewImage}
                                                                                            alt="PreviewImage"
                                                                                            className="fileView"
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                            {attachedFilenameFile ? (
                                                                                <span onClick={() => downloadCoreFile(transferChallan)}>
                                                                                    <Tooltip title="Download">
                                                                                        <img
                                                                                            src={downloadImage}
                                                                                            alt="downloadImage"
                                                                                            className={classes.downloadImg}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            ) : null}
                                                                        </span>
                                                                    ) : null}
                                                                    <PreviewModal
                                                                        fileSource={downloadPath}
                                                                        visibleClose={visible}
                                                                        handleModalClose={handleModalClose}
                                                                    />
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </FormControl>
                                                </div>
                                            </Grid>
                                        ) : null}

                                        {finalDraft && finalDraft.length ? (
                                            <Grid item xs={12} sm={12}>
                                                <div className="subtitle">Final statements uploaded by {dbname}</div>
                                                <span style={{ display: 'flex' }}>
                                                    {finalDraft.map((file) => {
                                                        return (
                                                            <div style={{ marginRight: '12px', marginBottom: '12px' }}>
                                                                <span className={classes.imageViewList}>
                                                                    <span
                                                                        className="fntSmall"
                                                                        style={{ marginRight: '7px', marginTop: '6px' }}
                                                                    >
                                                                        {file.substring(file.lastIndexOf('/') + 1).substring(0, 15)}
                                                                        {file.length > 15 ? '...' : ''}
                                                                    </span>

                                                                    {/* <span style={{ marginRight: '8px' }} className="fileName">{attachedFilename}</span> */}
                                                                    <span onClick={() => handlePreviewModal(file)}>
                                                                        <Tooltip title="Preview">
                                                                            <img
                                                                                src={PreviewImage}
                                                                                alt="PreviewImage"
                                                                                className="fileView"
                                                                            />
                                                                        </Tooltip>
                                                                    </span>
                                                                    <span onClick={() => downloadCoreFile(file)}>
                                                                        <Tooltip title="Download">
                                                                            <img
                                                                                src={downloadImage}
                                                                                alt="downloadImage"
                                                                                className={classes.downloadImageView}
                                                                            />
                                                                        </Tooltip>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        );
                                                    })}
                                                </span>
                                            </Grid>
                                        ) : null}
                                    </Grid>
                                </CardContent>
                            </Card>
                            <div className="footer-button">
                                {showBtnLoader ? (
                                    <LoaderPopUp
                                        showLoader={showBtnLoader}
                                        handleClose={handleClose}
                                        title="Please wait while approving the Tax payment"
                                    />
                                ) : null}
                                <ul>
                                    <li>
                                        <Button disabled={isDisable} color="primary" className="buttonnext txt-cap" type="submit">
                                            Submit
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
}
